<template>
  <section class="fshr-location-breadcrumbs">
    <ul class="fshr-location-breadcrumbs__list">
      <li
        v-for="location in breadcrumbs"
        :key="location.name"
        class="fshr-location-breadcrumbs__item"
      >
        <a :href="location.link" class="fshr-location-breadcrumbs__link">
          {{ location.name }}
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "Location-breadcrumbs",
  props: {
    locations: {
      type: Object,
      required: true,
    },
  },

  data() {
    const breadcrumbs = [];

    if (this.locations) {
      const { country, center } = this.locations;

      if (country) {
        breadcrumbs.push(country);
      }

      if (center) {
        breadcrumbs.push(center);
      }
    }

    return {
      breadcrumbs,
    };
  },
};
</script>
